import React from 'react';
import { Box, Typography } from '@mui/material';
import { SectionVariable } from '../types';
import { useTranslation } from '../i18n';

interface MarqueeProps {
  variables?: SectionVariable;
  name?: string;
}

export function Marquee({ variables }: MarqueeProps) {
  const { t } = useTranslation();
  const text = variables?.text?.[0] || t.marquee.defaultText;
  const repeatCount = 12;

  return (
    <Box
      className="marquee"
      sx={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        py: 2,
        bgcolor: 'var(--color-primary, #6B00D6)',
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          animation: 'marquee 30s linear infinite',
          '@keyframes marquee': {
            '0%': { transform: 'translateX(0)' },
            '100%': { transform: 'translateX(-50%)' },
          },
        }}
      >
        {Array.from({ length: repeatCount }).map((_, i) => (
          <Typography
            key={i}
            component="span"
            sx={{
              mx: 3,
              fontSize: { xs: '0.8rem', md: '0.9rem' },
              fontWeight: 500,
              color: '#FFF',
            }}
          >
            {text}
          </Typography>
        ))}
        {Array.from({ length: repeatCount }).map((_, i) => (
          <Typography
            key={`dup-${i}`}
            component="span"
            sx={{
              mx: 3,
              fontSize: { xs: '0.8rem', md: '0.9rem' },
              fontWeight: 500,
              color: '#FFF',
            }}
          >
            {text}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
